(ns frontend.ui.component.lp-portal.modal.edit-modals.edit-table-modal
  (:require
    [clojure.data :as data]
    [frontend.ui.component.modal-dialog.view :as modal-dialog]
    [frontend.ui.component.modal-dialog.style :as modal-style]
    [frontend.ui.component.lp-portal.modal.style :as style]
    [herb.core :as h]
    [common.localization :as loc]
    [reagent.core :as r]
    [ui.components.button.view :as button]
    [ui.color :as c]
    [ui.editors.data-input :as data-input]
    [frontend.ui.component.lp-portal.modal.edit-modals.events :as chart-editor-events]
    [frontend.tenant-customizations :as tenant-customizations]
    [frontend.ui.component.lp-portal.modal.edit-modals.invest-europe.table-data-editor :as invest-europe-components]
    [frontend.ui.component.lp-portal.modal.edit-modals.common :as common-components]))

(defn editable-table-row-text-only
  [{:keys [state row-idx row-data first-col-fixed? fixed-rows?]}]
  (->> row-data
       (map-indexed
        (fn [col-idx col]
          ^{:key (str col-idx "/" (count (:columns @state)) "/" (count (:data @state)))}
          [:td
           {:class (h/<class style/table-editor-cell (not (= col-idx 0)))}
           (if (= col-idx 0)
             [:div
              {:class (h/<class style/first-col-cell-container)}
              [:div
               {:class (h/<class style/table-header-cell)
                :id    "header-cell"}
               [data-input/view
                {:data-type :data.type/text-simple
                 :class     (h/<class style/table-header-input (not first-col-fixed?))
                 :value     (str col)
                 :on-change  #(chart-editor-events/update-value!
                               state
                               row-idx
                               col-idx
                               %)
                 :disabled? first-col-fixed?}]
               (when-not fixed-rows? 
                 [common-components/row-dropdown
                  {:state state
                   :row-idx row-idx
                   :add-row-to-index-before! #(chart-editor-events/add-row-to-index! state row-idx)
                   :add-row-to-index-after! #(chart-editor-events/add-row-to-index! state (+ row-idx 1))
                   :remove-row! #(chart-editor-events/remove-row! state row-idx)}])]]
             [data-input/view
              {:data-type :data.type/text-simple
               :class     (h/join (h/<class style/number-input)
                                  (h/<class style/full-width))
               :value     col
               :variant   :borderless
               :on-change  #(chart-editor-events/update-value!
                             state
                             row-idx
                             col-idx
                             %)}])]))))

(defn editable-table-with-text-data-only
  [{:keys [state no-columns? fixed-labels? fixed-columns? fixed-rows? has-colors? first-col-fixed?]}]
  (let [rows (:data @state)]
    [:table
     {:class (h/<class style/table)}
     [common-components/table-header-row state
      {:no-columns?    no-columns?
       :fixed-labels?  fixed-labels?
       :fixed-columns? fixed-columns?
       :fixed-rows?    fixed-rows?
       :has-colors?    has-colors?
       :add-column-to-index! chart-editor-events/add-column-to-index!
       :remove-column! chart-editor-events/remove-column!}]
     (when-not no-columns?
       (if (->> @state
                :data
                (every? empty?))
         [button/secondary-hollow
          {:on-click #(chart-editor-events/add-row! state)}
          (loc/tr :no-chart-data-available-row)]
         (into [:tbody]
               (->> rows
                    (map-indexed
                     (fn [row-idx row-data]
                       (into [:tr]
                             (editable-table-row-text-only {:state state 
                                                            :row-idx row-idx 
                                                            :row-data row-data 
                                                            :first-col-fixed? first-col-fixed?
                                                            :fixed-rows? fixed-rows?}))))))))]))

(defn view
  [{:keys [data]}]
  (let [state (r/atom data)]
    (fn [{:keys [hide! data visible? save! fixed-columns? fixed-labels? fixed-rows?
                 disable-heading-edit?]}]
      (let [no-columns? (->> @state
                             :columns
                             (empty?))
            no-changes? (let [[removed added _] (data/diff data @state)]
                          (and (empty? removed)
                               (empty? added)))
            capman? (tenant-customizations/capman?)]
        [modal-dialog/modal-dialog
         {:hide!        hide!
          :visible?     visible?
          :size         :xl
          :header-label (loc/tr :edit-table-data)
          :font-family  "Muli, sans-serif"
          :style        {:body {:margin-right "16px"}}}
         [:div
          {:style {:display "flex"
                   :gap     "20px"
                   :max-height "50vh"
                   :overflow-y "auto"}}
          (cond (and capman?
                     (every? (set (keys @state)) #{:columns :data}))
                [editable-table-with-text-data-only
                 {:state state
                  :no-columns?    no-columns?
                  :fixed-labels?  fixed-labels?
                  :fixed-columns? fixed-columns?
                  :fixed-rows?    fixed-rows?
                  :has-colors?    false}]
                (some #(= :original-data %) (keys @state))
                [invest-europe-components/editable-table-with-configurations
                 {:state state
                  :no-columns?    no-columns?
                  :fixed-labels?  fixed-labels?
                  :fixed-columns? fixed-columns?
                  :fixed-rows?    fixed-rows?
                  :disable-heading-edit? disable-heading-edit?}]
                :else
                [:div
                 (loc/tr :incorrect-chart-data [(pr-str (keys @state))])])]
         [:<>
          [:div
           {:class (h/<class modal-style/footer-left-container)}
           [button/primary-solid
            {:on-click  (fn [_]
                          (save! @state))
             :disabled? no-changes?}
            (loc/tr :save)]]

          [:div
           {:class (h/<class modal-style/footer-right-container)}
           [button/secondary-hollow
            {:color    ::c/secondary
             :on-click hide!}
            (loc/tr :cancel)]]]]))))
